import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PrintPurchaseOrderDto } from "../../../../core/models/orders/purchaseOrderLine";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { CommonModule } from "@angular/common";
import { HideEmptyDatePipe } from "../../../../shared/pipes/hidedate/hide-empty-date.pipe";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { FreightQuotationDetailComponent } from "../../../freight-quote/freight-quotation-detail/freight-quotation-detail.component";
import { SaleOrderLineAddressDto } from "../../../../core/models/orders/saleOrderLineAddressDto";

@Component({
  selector: "jni-print-purchase-order",
  templateUrl: "./print-purchase-order.component.html",
  styleUrls: ["./print-purchase-order.component.scss"],
  imports: [
    DialogModule,
    TableModule,
    ButtonModule,
    CommonModule,
    HideEmptyDatePipe,
    ModalStackerComponent,
    FreightQuotationDetailComponent,
  ],
})
export class PrintPurchaseOrderComponent {
  @Input() purchaseOrderLine: PrintPurchaseOrderDto[] = [];
  @Input() printPdfModal = false;
  @Input() saleOrderId = "";
  @Output() closePrintPdfModalEvent = new EventEmitter();
  @Output() openPdfScreenModalEvent = new EventEmitter<string>();
  selectedPurchaseOrderLine: PrintPurchaseOrderDto[] = [];
  selectedPurchaseOrderLineAddresses: SaleOrderLineAddressDto[] = [];
  showFreightEstimationModule = false;
  purchaseSaleOrderId = "";

  openPrinfPdfTab() {
    if (
      this.selectedPurchaseOrderLine?.length &&
      this.selectedPurchaseOrderLine?.length === 1
    ) {
      for (const item of this.selectedPurchaseOrderLine) {
        this.openPdfScreen(item?.purchaseOrderNumber || "");
      }
    } else if (
      this.selectedPurchaseOrderLine?.length &&
      this.selectedPurchaseOrderLine?.length > 1
    ) {
      for (const item of this.selectedPurchaseOrderLine) {
        const url = `/orders/po-email/${this.saleOrderId}/${item?.purchaseOrderNumber}`;
        window.open(url, "_blank");
      }
    }

    this.printPdfModal = false;
  }

  closePrinfPdfModal() {
    this.selectedPurchaseOrderLine = [];
    this.closePrintPdfModalEvent.emit();
  }

  openPdfScreen(purchaseOrderId: string) {
    // const url = `/orders/po-email/${this.saleOrderId}/${purchaseOrderId}`;
    // window.open(url, '_blank');
    this.openPdfScreenModalEvent.emit(purchaseOrderId);
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  redirectToFreightEstimationPage(orderLine: PrintPurchaseOrderDto) {
    this.showFreightEstimationModule = true;
    this.printPdfModal = false;
    this.purchaseSaleOrderId = orderLine.purchaseOrderNumber;
  }

  closeFreightEstimationModule() {
    this.showFreightEstimationModule = false;
  }
}
